export default "__VITE_PUBLIC_ASSET__edd2ddde__"